import { css } from '@emotion/core';
var _ref = {
  name: "1l0z8uk",
  styles: "flex-direction:row;"
};
var _ref2 = {
  name: "1mcrfa7",
  styles: "max-width:33%;"
};
var _ref3 = {
  name: "3ra2f4",
  styles: "display:flex;gap:16px;flex-direction:row;"
};
export default (_ref4 => {
  var layout = _ref4.layout;
  var articleWrapper = /*#__PURE__*/css("display:flex;flex-direction:column;gap:16px;", layout === 'row' && _ref);
  var card = layout === 'row' ? _ref2 : null;
  var secondRow = _ref3;
  return {
    articleWrapper,
    card,
    secondRow
  };
});